<template>
  <div>
    <menu-pae></menu-pae>
    <div class="align-content-center">
      <div class="alert alert-success text-center">
        <h4 class="box-title">Protocolo Tramitado com Sucesso!</h4>
        <div class="col-md-12">
          <h1 v-for="processo in guia" :key="processo.numero">{{ processo.numero }}</h1>
          <br/>
          <button class="btn btn-success" @click.prevent="gerarGuia"> Gerar Guia de Tramitação </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import menuPae from '@/components/Menu.vue'
import VirtusRepositoryService from '@/services/VirtusRepositoryService'

import { mapState } from 'vuex'

export default {
  components: {
    menuPae
  },

  created () {
    this.numeroProcesso = this.$route.query.numeroProcesso
    this.apensado = this.$route.query.apensado
    this.lote = this.$route.query.lote
    this.virtusRepositoryService = new VirtusRepositoryService()
  },

  computed: mapState({
    guia: state => state.processosGuia
  }),

  methods: {
    gerarGuia () {
      this.virtusRepositoryService.dowloadGuiTramite(this.lote).then((res) => {
        const blob = new Blob([res.data], { type: 'application/pdf' })

        var filename = `guia${this.lote}.pdf`

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob)
        } else {
          var fileURL = URL.createObjectURL(blob)
          window.open(fileURL, filename)
        }
      }).catch(err => {
        console.log(err)
      })
    }
  },

  destroyed () {
    this.$store.commit('MUT_PROCESSO_GUIA', [])
  }
}
</script>

<style scoped lang="scss">
</style>
